// components
import maPaginator from '@/components/paginator'
import maFilters from '../../components/filters'
import maModal from '@/components/modal'
import maInputText from '@/components/input/modules/text'
import maAdminView from '../adminView'
import maEmpty from '@/components/empty'

// api
import {
  apiGetAdminDamagesTransversalscosts,
  apiPatchAdminDamagesTransversalscosts
} from '@/services/API/admin'

export default {
  name: 'transversalcosts',
  data: function () {
    return {
      transversalcost: {
        componentName: null,
        costFormat: null,
        damageType: null,
        description: null,
        value: null
      }
    }
  },
  extends: maAdminView,
  components: {
    maPaginator,
    maFilters,
    maModal,
    maInputText,
    maEmpty
  },
  methods: {
    handleSearch: function () {
      apiGetAdminDamagesTransversalscosts(this.currentPage, this.filterWarrantyId, this.filterSubwarrantyId)
        .then(transversalCosts => {
          this.table = transversalCosts.results
          this.totalPages = transversalCosts.total_pages || 0
        })
    },
    handleEdit: function (componentName, description, costFormat, damageType, value) {
      this.transversalcost = { componentName, description, costFormat, damageType, value }
      this.$refs.adminEditModal.showModal = true
    },
    resetEditValues: function () {
      this.transversalcost.componentName = null
      this.transversalcost.costFormat = null
      this.transversalcost.damageType = null
      this.transversalcost.description = null
      this.transversalcost.value = null
    },
    handleSave: function () {
      apiPatchAdminDamagesTransversalscosts(
        this.transversalcost.componentName,
        this.transversalcost.costFormat,
        this.transversalcost.damageType,
        this.transversalcost.description,
        this.transversalcost.value
      )
        .then(() => {
          this.handleSearch()
          this.throwNotification(this.$t('notifications.paramChanged.title'), this.$t('notifications.paramChanged.body'), 'OK')
          this.$refs.adminEditModal.showModal = false
        })
        .catch(() => {
          this.throwNotification(this.$t('notifications.error.0.title'), this.$t('notifications.error.0.body'), 'KO')
        })
    }
  },
  mounted: function () {
    this.handleSearch()
  }
}
